//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ReturnHtmlDefaultToTrueForDocuments: FeatureFlag = {"Id":"ReturnHtmlDefaultToTrueForDocuments","Label":"(QA) Return source HTML instead of a PDF to download for PDF downloads","Impact":"For QA. Returns inline HTML instead of PDF when downloading PDFs","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":4};
